
import React, { useEffect, useState, useRef, } from "react";
import {
    Row,
    Col,
    Form,
    Input,
    Switch,
    Select,
    useCRUDController,
    InputNumber,
    Textarea
} from '../../ui/ot'
import { useTranslation } from "react-i18next";

const FrameworkManagementForm = ({
    propsForm,
    field,
    onFormFinish = () => { },
    keyPrefix = "cataloging.framework_management",
}) => {

    const [form_] = Form.useForm();
    const form = propsForm ? propsForm : form_
    const [count, setCount] = useState(0);
    const axiosMode = Form.useWatch([field?.name ?? '', 'axiosMode'].join('.'), form)
    
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
        
    };
    const onFinish = (values) => {
        onFormFinish({
            ...values,
        });

    };
    const onValuesChange = (value, { name, type }) => {

        let formValues = null;
        formValues = form.getFieldsValue();
    };


    const getAnyFormValue = (name, count) => {
        let formValues = null;
        formValues = form.getFieldValue(name);
        return formValues;
    };

    useEffect(() => {
        setDataInitialization();
    }, []);


    return (
        <Row>
            <Col span={24}>
                <Form
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"

                >
                    <Row>
                        <Col span={24}>
                            <FormItemComponent
                                axiosMode={axiosMode}
                                field={field}
                                getAnyFormValue={getAnyFormValue}
                                count={count}
                                setFieldValue={form.setFieldValue}
                                setCount={setCount}
                                keyPrefix={keyPrefix}
                            />
                        </Col>
                    </Row>

                </Form >
            </Col >
        </Row >
    );
};
const FormItemComponent = ({
    field,
    initialValues = {},
    keyPrefix = "library",
    axiosMode,
 
}) => {
    const { t } = useTranslation('translation', { keyPrefix })

    return (
        <>
            <Row>
                <Col span={24}>
                    <Row>
                        <Col span={24} >
                            <Form.Item
                                labelCol={4}
                                wrapperCol={20}
                                {...field}
                                name={[field?.name ?? '', 'frameworkcode']}
                                fieldKey={[field?.fieldKey ?? '', 'frameworkcode']}
                                label={t('frameworkcode')}
                                rules={[{
                                    required: true,
                                    message: t('please_input_item')
                                }]}
                                extra={t('framework_code_limit')}
                            >
                                <Input maxLength={4} disabled={axiosMode === "patch"} />
                            </Form.Item>
                        </Col>
                        <Col span={24} >
                            <Form.Item
                                labelCol={4}
                                wrapperCol={20}
                                {...field}
                                name={[field?.name ?? '', 'frameworktext']}
                                fieldKey={[field?.fieldKey ?? '', 'frameworktext']}
                                label={t('frameworktext')}
                                rules={[{ required: true, message: t('please_input_item') }]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>


                    </Row>
                </Col>
            </Row>
        </>
    );
};





export default FrameworkManagementForm;
